import { useState } from "react";
import { toast } from "sonner";
import { Play, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { Select } from "@/components/shop/common";

export default function TimePanel({ wo, techs, reload, myTech }) {
  const [tech, setTech] = useState(myTech || "");
  const open = wo.time_entries.filter((e) => !e.end);
  const name = (id) => techs.find((t) => t.id === id)?.name || "Tech";

  const clockIn = async () => {
    try { await api.post("/time/clock-in", { technician_id: tech, work_order_id: wo.id }); toast.success(`${name(tech)} clocked in`); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const clockOut = async (id) => {
    try { await api.post(`/time/${id}/clock-out`); toast.success("Clocked out"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-3" data-testid="time-panel">
      {wo.status !== "invoiced" && (
        <div className="flex gap-2">
          <Select value={tech} onChange={(e) => setTech(e.target.value)} placeholder="Select tech" options={techs.map((t) => ({ value: t.id, label: t.name }))} data-testid="time-tech-select" />
          <Button onClick={clockIn} disabled={!tech} className="rounded-sm shrink-0 hover:bg-orange-600 hover:text-white" data-testid="clock-in-btn"><Play className="h-4 w-4 mr-1" /> Clock in</Button>
        </div>
      )}
      {open.map((e) => (
        <div key={e.id} className="flex items-center justify-between border border-orange-500/40 bg-orange-500/10 rounded-sm px-3 py-2 text-sm" data-testid={`open-clock-${e.id}`}>
          <span><span className="inline-block h-2 w-2 rounded-full bg-orange-500 animate-pulse mr-2" />{name(e.technician_id)} since {new Date(e.start).toLocaleTimeString()}</span>
          <button onClick={() => clockOut(e.id)} className="flex items-center gap-1 text-orange-300 hover:text-white" data-testid={`clock-out-${e.id}`}><Square className="h-3.5 w-3.5" /> Stop</button>
        </div>
      ))}
      <div className="text-xs font-mono text-muted-foreground space-y-1">
        {wo.time_entries.filter((e) => e.end).map((e) => (
          <p key={e.id}>{name(e.technician_id)} · {new Date(e.start).toLocaleString()} · {e.hours}h</p>
        ))}
      </div>
      <p className="text-sm" data-testid="actual-hours">Actual hours logged: <span className="font-mono text-primary">{wo.actual_hours}</span> · Billed: <span className="font-mono">{wo.labor_lines.reduce((a, l) => a + l.hours, 0)}</span></p>
    </div>
  );
}
